// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3164) return "css/3164.67abf2726a9c53e1.css";
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"4556":"32e6f08c5a370d28","5261":"c730db16cc6ce76d","8845":"0d7c6ad3f8fc7462"}[chunkId] + ".css";
};